import { render, staticRenderFns } from "./PlatformBreakdown.vue?vue&type=template&id=0cd2db4a&scoped=true"
import script from "./PlatformBreakdown.vue?vue&type=script&lang=js"
export * from "./PlatformBreakdown.vue?vue&type=script&lang=js"
import style0 from "./PlatformBreakdown.vue?vue&type=style&index=0&id=0cd2db4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2db4a",
  null
  
)

export default component.exports